import * as v from "valibot";

import { rpcContract } from "../rpc";

export const deleteUserRpcContract = rpcContract({
  name: "deleteUser",
  paramsSchema: v.object({
    userId: v.pipe(
      v.string(),
      v.regex(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i, "Wrong User id"),
    ),
  }),
  resultSchema: v.undefined(),
});

export type DeleteUserParams = v.InferOutput<(typeof deleteUserRpcContract)["paramsSchema"]>;
export type DeleteUserResult = v.InferOutput<(typeof deleteUserRpcContract)["resultSchema"]>;
